import Grid from '@mui/system/Grid';
import styled from '@mui/system/styled';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/system/Grid": Grid, "@mui/system/styled": styled } } });
export default ClientProvider;
